/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */

import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef, OnChanges, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BoardTypes } from 'app/content-result/category-result/filters-model';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { AccordionInfoProductComponent } from 'app/shared/modals-results-categories/accordion-info-product/accordion-info-product.component';
import { AccordionConfig, AccordionItem } from 'app/shared/modals-results-categories/accordion-info-product/accordion-info.interface';
import { DailyPrices, ICancellationPolicyModalResultsDisplayData, IDetailRoomsModalHotelDisplayData } from 'model/view-models/results/product-card/price-display-data.interface';
import { HotelService, ConfigSelectedRoomChangeEvent } from '../hotel.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss'],
  providers: [CurrencyConverterPurePipe ],
})
export class RoomComponent implements OnInit, OnChanges {
  @ViewChild('selectedRoomsDiv') selectedRoomsDiv!: ElementRef;
  @ViewChild('containingDiv') containingDiv!: ElementRef;
  @ViewChild('contentBorderSelectTop') contentBorderSelectTop: ElementRef;
  @ViewChild('contentBorderSelectMiddle') contentBorderSelectMiddle: ElementRef;
  @ViewChild('contentBorderSelectBottom') contentBorderSelectBottom: ElementRef;
  @ViewChild('politicsAccordion') politicsAccordion: any;
  @ViewChild('politicsSection') politicsSection!: ElementRef;
  @ViewChild('selectRoom') selectRoom!: ElementRef;
  @ViewChild('accordionComponent') accordionComponent!: AccordionInfoProductComponent;
  @ViewChildren('accordionDetailComponent') accordionDetailComponent!: QueryList<AccordionInfoProductComponent>;
  @ViewChildren('accordionDetailContent') accordionDetailContent!: QueryList<ElementRef>;




  @Input() room: any;
  @Input() room_: any;
  @Input() allRoom: any;
  @Input() select: any[];
  @Input() index: number;
  @Input() productQty: number;
  @Input() reserveMultiHab: boolean;
  @Input() hotelAdditionalInfo: any;
  @Input() roomsSearch: any[] = [];
  @Input() departureDate: any;
  @Input() hotelDescription: string;
  @Input() buttonTextActive: string;
  @Input() clientSetting: any;
  @Input() buttonColorActive: string;
  @Input() backgroundSelect: string;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() paymentAgencyActive: any;
  @Input() last = false;
  @Input() arrivalDate: Date;
  @Input() payload: any;
  @Input() selectedRoomsParent: any;
  @Input() selectedRoomsFilterVisible!: boolean;
  @Output() totalProfRooms = new EventEmitter<number>();
  @Output() calculateTotalPrice = new EventEmitter<any>();
  @Output() calculateTotalPriceWithout = new EventEmitter<any>();
  @Output() pushRoomSearch = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();
  @Output() indexRoom = new EventEmitter<number>();
  @Output() refreshCalculatePrice = new EventEmitter<any[]>();
  @Output() roomMoved = new EventEmitter<any>();
@Output() roomRemoved = new EventEmitter<any>();
@Output() roomAdded = new EventEmitter<any>();
  qtySelect = 0;
  currentDate: Date = new Date(); // Esto establecerá la fecha actual

  roomsIndex = 0;
  @Input() images: any[];

  step = null;
  imgSelect = 0;
  uniqBoardName = {};
  uniqRateClass = {};
  imgCoverRoom: string;
  dataRoom: any;
  imgRoomsSlider: any = [];

  uniq_ = {};
  roomSelect: any;
  checkSelect: any;
  roomBoardName: any;
  roomRateClass: any;
  amenitiesHotelRooms = [];
  roomAmenits: any = [];

  nightsTotalProf = 0;
  roomsTotalProf = 0;

  totalAdults = 0;
  totalChildren = 0;

  currentOptionIndex = 0;
  selectedOptionIndex = 0;

  public promotionOverlayPositions: ConnectedPosition[] = [
    { originX: 'center', originY: 'top', overlayX: 'center', overlayY: 'bottom', offsetY: -6 },
    { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 6 }
  ];

  public dailyPricesArr: DailyPrices[] = [];

  last1 = 50;
  last2 = -50;
  num1 = 0;
  num2 = 0;
  regimeArr = [];
  conditionArr = [];
  setFirstValueReg = '';
  availableRoom = false;
  amenitiesRoom = false;
  public _form: any;
  public selectedRooms: any[] = [];
  availableRooms = [];
  roomToDelete: any = null;
  boardNameSelect: any;
  form: any;
  imgRoomCover: any;
  objectImagesStaticRoom = {
    type: 'App\\Models\\Hotel',
    image: 'https://hg-static.hyperguest.com/30205/images/image_2003636_original.jpg',
    thumbnail: 'https://hg-static.hyperguest.com/30205/images/image_2003636_original.jpg',
    isCover:true //Agregue esta propiedad para que cuando este en el punto del filter funcione correctamente y no genere error.
  };
  imageRoomById: any[] = [];
  roomImage = 'assets/img/app/hotel_default.png';
  showDetails: boolean[] = [];

  // private extrasMap = new WeakMap<any, any[]>();
  private priceMap = new WeakMap<any, number>();
  isMainExpanded = true;
  isMainExpandedExcutiveAction: any[] = [];
  isMainExpandedDetailExcutiveAction: any[] = [];
  // private priceModifiersMap = new WeakMap<any, number>();

    private readonly BOARD_ICONS: { [key: string]: string } = {
  breakfast: 'assets/icons/meals-hotel-modal/01_DESAYUNO.svg',
  no_breakfast: 'assets/icons/meals-hotel-modal/02_NO_DESAYUNO.svg',
  half_board: 'assets/icons/meals-hotel-modal/03_MEDIA_PENSION.svg',
  full_board: 'assets/icons/meals-hotel-modal/04_PENSION_COMPLETA.svg',
  all_inclusive: 'assets/icons/meals-hotel-modal/05_ALL_INCLUSIVE.svg'
};

cancellationData!: any;
accordionItemsData!: any[];
accordionConfigData!: any;
descriptionData: SafeHtml = '';
amenitiesData: SafeHtml = '';

cancellationDetailData!: any;
accordionItemsDetailData!: any[];
accordionConfigDetailData!: any;

groupedRoomOptions: any[] = [];
selectedRoom: any = null;
availableConfigs: any[] = [];
configSelectedRoom: { [key: string]: any[] } = {};
 isDetailOpen = false;
 indexOpened = -1;

  bsModalRef?: BsModalRef;
  config = {
    animated: true,
    keyboard: true,
    backdrop: 'static',
    ignoreBackdropClick: true,
  };

private readonly DEFAULT_ICON = 'assets/img/app/hotel_default.png';
selectedExtrasByRoom: Map<any, any[]> = new Map();
  constructor(private cdr: ChangeDetectorRef,
              private currencyPipe: CurrencyConverterPurePipe,
              private modalService: BsModalService,
              private sanitizer: DomSanitizer,
              private notificationService: NotificationService,
              private hotelService: HotelService) {}
  ngOnChanges(changes: SimpleChanges): void {
console.log(changes)
    if(changes['selectedRoomsParent']  &&  (changes['selectedRoomsParent'].currentValue !== changes['selectedRoomsParent'].previousValue)) {
      this.selectedRoomsParent = changes['selectedRoomsParent'].currentValue;
    }
  }

  ngOnInit() {
    this.hotelService.clearAllSelectedRooms();
    this.resetSelect();
    this.roomSelect = this.roomBoardName[this.roomsIndex];
    this.foundIdRoom();
    this.imgRoomCover = this.roomSelect?.room.images.filter(e => e.isCover);
    this.multiplyTotalProf();
    this.form = JSON.parse(localStorage.getItem('form'));
    this.dataRoom = this.hotelAdditionalInfo;
    this.getMoreAmenities();
    this.dailyPriceSelect(this.roomSelect);
    this.createAddonsEmpty();
    this.cancellationData = this.getCancellationPolicies();
    this.accordionItemsData = this.getAccordionItems();
    this.accordionConfigData = this.getAccordionConfig();
    this.descriptionData = this.formatHotelDescription(this.hotelDescription);
    this.amenitiesData = this.formatAmenities(this.hotelAdditionalInfo);

    this.subscribeChangeDetail();
    this.subscribeConfigSelectedRoomChanges();

   if (this.roomBoardName && this.roomBoardName.length > 0) {
    this.selectedOptionIndex = 0;
    this.onChangeBoardName('0', this.roomBoardName[0], 0);
  }
  this.groupRoomOptions();
  }

  subscribeChangeDetail(): void {
     this.hotelService.detailData$.subscribe(data => {

    if (data && data.roomCode) {

      const roomFind = this.room.find(c => `${c.room?.roomType}_${c.room?.boardName}_${c.room?.rateClass}_${c.room?.roomCode}` === data?.roomCode);
      const roomIndex = this.room.findIndex(c => `${c.room?.roomType}_${c.room?.boardName}_${c.room?.rateClass}_${c.room?.roomCode}` === data?.roomCode);

      if(roomFind) {
         this.isDetailOpen = data.isOpen || false;
         this.indexOpened = roomIndex;
      } else {
        this.isDetailOpen = false;
        this.indexOpened = -1;
      }

    } else {
      this.isDetailOpen = false;
    }
  });

  // ✅ También suscribirse al estado directo
  this.hotelService.detailOpenState$.subscribe(state => {

    const roomCode = this.room?.roomCode;
    if (roomCode) {

      this.isDetailOpen = state[roomCode] || false;
    }
  });


  }

  subscribeConfigSelectedRoomChanges(): void {
    this.hotelService.configSelectedRoomChange$.subscribe((event: ConfigSelectedRoomChangeEvent | null) => {
      if (!event) {
        return;
      }

const roomFind = this.room.find(c => `${c.room?.roomType}_${c.room?.boardName}_${c.room?.rateClass}_${c.room?.roomCode}` === event?.groupedKey);
const roomIndex = this.room.findIndex(c => `${c.room?.roomType}_${c.room?.boardName}_${c.room?.rateClass}_${c.room?.roomCode}` === event?.groupedKey);


if(roomFind) {
        this.handleConfigSelectedRoomChangeFromAnother(event);
      }

      this.cdr.detectChanges();
    });
  }

  private handleConfigSelectedRoomChangeFromAnother(event: ConfigSelectedRoomChangeEvent): void {
    const { action, groupedKey, occupancyRoom } = event;

    if (action === 'removed') {
      const localIndex = this.selectedRooms.findIndex(
        item => item?.service?.occupancyRoom === occupancyRoom
      );

      if (localIndex !== -1) {
        this.selectedRooms.splice(localIndex, 1);

        if (this.selectedRooms.length === 0 && this.contentBorderSelectTop) {
          this.contentBorderSelectTop.nativeElement.style.border = '1px solid #bfbfbf';
          this.contentBorderSelectTop.nativeElement.style.boxShadow = 'none';
        }
      }
    }

    if (action === 'added') {
      this.onRoomAddedFromAnother(occupancyRoom, event.option?.room, groupedKey);
    }
  }

formatAmenities(hotel: any): SafeHtml {
  if (!hotel?.amenities || hotel?.amenities.length === 0) {
    return this.sanitizer.bypassSecurityTrustHtml('<p>No hay amenities disponibles</p>');
  }

  const colorClient = this.clientSetting?.clients_setting_global?.color_main_1;

  // ✅ Filtrar amenities relevantes (excluir códigos de grupo 10, 20, 30, etc.)
  const relevantAmenities = hotel.amenities.filter((a: any) => {
    // ✅ Excluir amenities que no son relevantes para mostrar
    const excludeCodes = [''];
    return !excludeCodes.includes(a.amenity_group_code) && a.amenity_name;
  });

  // ✅ Agrupar por grupo (opcional)
  const groupedAmenities: { [key: string]: any[] } = {};
  relevantAmenities.forEach((a: any) => {
    const group = a.amenity_group_code || 'otros';
    if (!groupedAmenities[group]) {
      groupedAmenities[group] = [];
    }
    groupedAmenities[group].push(a);
  });

  // ✅ Generar HTML
  let html = '<div style="background-color: white; margin-top: -15px;">';

  // ✅ Opción 1: Lista simple
  html += '<ul style="list-style: none; padding: 0; margin: 0; display: flex; flex-wrap: wrap; gap: 8px;">';
  relevantAmenities.forEach((a: any) => {
    html += `
      <li style="display: flex; align-items: center; width: 48%; margin-bottom: 4px;">
        <i class="bi bi-check" style="color: ${colorClient}; font-size: 1.8em; margin-right: 3px;"></i>
        <span style="font-family: 'Rubik', sans-serif; font-size: 15px; font-weight: 500; color: #333;">${a.amenity_name}</span>
      </li>
    `;
  });
  html += '</ul>';


  html += '</div>';

  return this.sanitizer.bypassSecurityTrustHtml(html);
}

/**
 * Agrupa las opciones de habitación por boardName, rateClass y roomCode
 */
groupRoomOptions(): void {
  const groups: { [key: string]: any[] } = {};

  this.roomBoardName.forEach((item: any) => {
    const room = item.room;
    const key = `${room.boardName}_${room.rateClass}_${room.roomCode}`;

    if (!groups[key]) {
      groups[key] = [];
    }
    groups[key].push(item);
  });

  // ✅ Convertir a array para el template
  this.groupedRoomOptions = Object.keys(groups).map(key => {
    const group = {
      key,
      options: groups[key],
      boardName: groups[key][0]?.room?.boardName,
      rateClass: groups[key][0]?.room?.rateClass,
      roomCode: groups[key][0]?.room?.roomCode,
      roomType: groups[key][0]?.room?.roomType,
      allotment: groups[key][0]?.room?.availability?.allotment,
      minPrice: Math.min(...groups[key].map((o: any) => o.room.netPriceProf || 0)),
      selectedOccupancy: this.getSelectedOccupancy(groups[key]),
      // ✅ Guardar configuraciones disponibles dentro del grupo
      availableConfigs: this.getAvailableConfigsForGroup(groups[key], key)
    };
    return group;
  });

}

/**
 * Obtiene las configuraciones disponibles para un grupo
 */
getAvailableConfigsForGroup(options: any[], groupKey: string): any[] {
  const roomConfigs = this.payload?.others?.hotels?.roomConfiguration || [];
  const availableConfigs: any[] = [];
  const assignedConfigs = this.selectedRoomAssignments[groupKey] || [];
  const assignedIndexes = assignedConfigs.map((a: any) => a.configIndex);
  const maxRooms = 9;

  roomConfigs.forEach((config: any, index: number) => {
    // ✅ Saltar configuraciones ya asignadas a este grupo
    if (assignedIndexes.includes(index)) {
return;
}

    const totalPax = (config.adults || 0) + (config.children?.length || 0);

    // ✅ Buscar una opción en el grupo que coincida con la ocupación
    const match = options.find((o: any) => o.room.occupancyRoom === (index + 1));
    if (match) {
      availableConfigs.push({
        configIndex: index,
        config,
        totalPax,
        option: match,
        adults: config.adults || 0,
        children: config.children || [],
        childrenCount: config.children?.length || 0
      });
    }
  });

  // ✅ Llenar hasta 9 con placeholders
  for (let i = availableConfigs.length; i < maxRooms; i++) {
    availableConfigs.push({
      configIndex: null,
      config: null,
      totalPax: null,
      option: null,
      adults: null,
      children: null,
      childrenCount: null,
      isEmpty: true
    });
  }
  return availableConfigs;
}

/**
 * Obtiene la ocupación seleccionada para este grupo
 */
getSelectedOccupancy(options: any[]): any | null {
  // ✅ Buscar la opción que coincida con la configuración de búsqueda
  const roomConfig = this.payload?.others?.hotels?.roomConfiguration || [];

  let num = 0;

  for (const config of roomConfig) {

    const adults = config.adults || 0;
    const children = config.children?.length || 0;
    const totalPax = adults + children;

    // ✅ Buscar una opción que coincida con la ocupación
    const match = options.find((o: any) => o.room.occupancyRoom === (num + 1));
    if (match) {
      return {
        occupancy: totalPax,
        option: match,
        adults,
        children,
        childrenAges: config.children || []
      };
    }

    num++;
  }

  return null;
}


  createAddonsEmpty(): void {
    this.room.forEach((room: any) => {
        room.room.addonsIncluded = [];
        room.room.netPriceBookingAddons = 0;
    });
  }


  onSelectionChange(index: any, room: any) {


     if(this.selectedRoomsParent.length > 0) {

            const occupancyParent = this.selectedRoomsParent.map(c => c.room.room.occupancyRoom);

            if (occupancyParent.includes(room.room.occupancyRoom)) {
            return;
          }
        }




    const selectedRoom = this.roomsSearch[room.room?.occupancyRoom - 1];
    const indexRoom = room.room?.occupancyRoom - 1;


    if(!selectedRoom) {
      return;
    }

      this.roomSelect.room.adults = selectedRoom.qtyAdults;
      this.roomSelect.room.childrens = selectedRoom.qtyChilds;
      room.adults = selectedRoom.qtyAdults;
      room.childrens = selectedRoom.qtyChilds;
      room.childsAge = selectedRoom.childsage;

      // const selectedRoom = this.roomsSearch[selectedIndex];

      const addRoomSelected = { room: selectedRoom, service: room.room};

     this.addRoom(addRoomSelected);



      // this.selectedRooms.push(addRoomSelected);

      // Encuentra el índice de selectedRoom en formRoom
      const formRoom = this.form.room;
      // En la primera carga de resultados el formRoom esta guardado como un array por más que sea un solo objeto
      if(formRoom.length && Array.isArray(formRoom)) {

        const formRoomIndex = room.room?.occupancyRoom - 1;
        const checkAll = this.selectedRooms.length > 0;

        if (checkAll) {

            // Eliminamos la habitación seleccionada de la lista de opciones disponibles
          // this.roomsSearch.splice(selectedIndex, 1);
          this.contentBorderSelectTop.nativeElement.style.border = `2px solid ${this.clientSetting.clients_setting_global?.color_main_1} `;
          this.contentBorderSelectTop.nativeElement.style.boxShadow = `0 4px 8px rgba(0, 0, 0, 0.15)`;

          this.calculateTotalPrice.emit(room);
          this.indexRoom.emit(formRoomIndex);

          this.selectionChange.emit(this.roomsSearch);
        } else {
          this.calculateTotalPrice.emit(0);
        }
        // Desde el + del fee esto viene como un objeto, por eso hay que transformarlo en un array
      } else {

        const formRoomArr: any[] = [];
        formRoomArr.push(formRoom);
        const formRoomIndex = room.room?.occupancyRoom - 1;
        const checkAll = this.selectedRooms.length > 0;

        if (checkAll) {

            // Eliminamos la habitación seleccionada de la lista de opciones disponibles
          // this.roomsSearch.splice(selectedIndex, 1);
          // Accede al elemento DOM y aplica un estilo
          this.contentBorderSelectTop.nativeElement.style.border = `2px solid ${this.clientSetting.clients_setting_global?.color_main_1} `;
          this.contentBorderSelectTop.nativeElement.style.boxShadow = `0 4px 8px rgba(0, 0, 0, 0.15)`;
          this.calculateTotalPrice.emit(room);
          this.indexRoom.emit(formRoomIndex);
          this.selectionChange.emit(this.roomsSearch);
        } else {
          this.calculateTotalPrice.emit(0);
        }
      }

      if(this.selectRoom) {
        this.selectRoom.nativeElement.value = null;
      }



  }

  selectOption(event: Event, index: number, option: any) {
    const checkbox = event.target as HTMLInputElement;

    // Si es el mismo índice y se está intentando desmarcar, prevenir
    if (this.selectedOptionIndex === index && !checkbox.checked) {
      event.preventDefault(); // Previene el cambio
      checkbox.checked = true; // Fuerza a que quede marcado
      return;
    }

    // Si no es el mismo índice, permitir el cambio
    if (this.selectedOptionIndex !== index) {
      this.selectedOptionIndex = index;
      this.onChangeBoardName(index.toString(), option, index);
    }


  }

  // En el componente hijo (usb-room)


offSelectionRooms(roomSelect: any, selectedIndex: any, room?: any, template?: boolean, deleteOtherRoom?: boolean, offSelectedRoom?: any) {


  const selectedIndex2 = parseInt(selectedIndex, 10);

  const roomEmit = {
    roomSelect,
    selectedIndex
  };

  this.calculateTotalPriceWithout.emit(roomEmit);

  let occupancyRoomToRemove: number | null = null;
  let roomDataToRemove: any = null;
  let groupedKeyToRemove: string | null = null;

  if (deleteOtherRoom) {
    // ✅ Eliminar del array padre (selectedRoomsParent)
    const removedRoom = offSelectedRoom;

    if (removedRoom) {
      roomDataToRemove = removedRoom?.room?.room || removedRoom?.room;

      occupancyRoomToRemove = roomDataToRemove?.occupancyRoom;

      if (roomDataToRemove) {
        groupedKeyToRemove = `${roomDataToRemove?.roomType}_${roomDataToRemove?.boardName}_${roomDataToRemove?.rateClass}_${roomDataToRemove?.roomCode}`;
      }

      const room = {
        room: removedRoom?.room
      };
    }

    // ✅ EMITIR EVENTO AL PADRE PARA QUE NOTIFIQUE A OTROS HIJOS
    if (occupancyRoomToRemove) {
      this.roomRemoved.emit({
      occupancyRoom: occupancyRoomToRemove,
      groupedKey: groupedKeyToRemove,
      roomData: roomDataToRemove,
      action: 'removed'
    });
    }

    return;
  }

  // ✅ Eliminar del array local
  const removedRoom = this.selectedRooms.splice(selectedIndex2, 1)[0];

  if (this.selectedRooms.length === 0) {
    this.contentBorderSelectTop.nativeElement.style.border = '1px solid #bfbfbf';
    this.contentBorderSelectTop.nativeElement.style.boxShadow = `none`;
  }

  if (removedRoom) {
    roomDataToRemove = removedRoom?.service || removedRoom?.room;
    occupancyRoomToRemove = roomDataToRemove?.occupancyRoom;

    if (roomDataToRemove) {
      groupedKeyToRemove = `${roomDataToRemove?.roomType}_${roomDataToRemove?.boardName}_${roomDataToRemove?.rateClass}_${roomDataToRemove?.roomCode}`;
    }

      const room = {
        room: removedRoom?.service
      };
      // this.hotelService.toggleConfigSelectedRoom(groupedKeyToRemove, room);

  }
}



  getNameRateClass(rateClass) {
      let rateClass_;
      switch (rateClass) {
        case 'NR': {
          rateClass_ ='No Reembolsable';
          break;
        }
        case 'R': {
          rateClass_ ='Reembolsable';
          break;
        }
    }
    return rateClass_;
  }

  resetSelect() {
    this.roomBoardName = this.room;
  }


  //regimen.
onChangeBoardName(roomsIndex: any, option: any, index: any) {
  // Obtener el boardName directamente del objeto option
  const boardName = option?.room?.boardName || '';
  this.boardNameSelect = boardName;
  this.setFirstValueReg = boardName;

  let roomsSearch = this.room;
  const roomsSearchAux = [];
  const roomsSearchAux_ = [];
  const i = 0;
  const uniq = {};

  if (roomsIndex == '-1') {
    // No hacer nada si es -1
  } else {
    // Seleccionar la opción
    this.roomSelect = this.roomBoardName[roomsIndex];
    this.dailyPriceSelect(this.roomSelect);
    // Filtrar rooms por boardName
    roomsSearch = roomsSearch.filter(function(entry: any) {
      return entry.boardName === boardName;
    });

    this.resetSelect();
  }

}

/**
 * Calcula cuántas habitaciones de esta opción específica ya están seleccionadas
 * Usa roomCode como identificador único
 */
getSelectedCountForCurrentOption(roomSelect: any): number {
  const currentRoomCode = roomSelect?.room?.roomCode;
  return this.selectedRooms.filter(room =>
    room?.service?.roomCode === currentRoomCode
  ).length;
}

/**
 * Verifica si el select debe estar deshabilitado
 */
isSelectDisabled(roomSelect: any): boolean {
  const allotment = roomSelect?.room?.availability?.allotment || 0;
  const selectedCount = this.getSelectedCountForCurrentOption(roomSelect);

  const isAllotmentFull = selectedCount === allotment;
  const isPaymentInvalid = !this.validPaymentConditionAgencyAvailable(this.roomSelect?.room?.rateClass);

  return isAllotmentFull || isPaymentInvalid;
}

  stingUpperCase(str) {
    if (typeof str === 'string') {
      const e = str.toLowerCase();
      return e.replace(/\b\w/g, (l) => l.toUpperCase());
    }

    return str;
  }

  multiplyTotalProf(): void {
    const totalProfNight = this.roomSelect.optionNightsNetTotalProf;
    const productTotal = this.productQty;
    this.roomsTotalProf = totalProfNight * productTotal;
  }

  getMoreAmenities(){
    let newArray = [];
    if(this.dataRoom) {
        newArray = this.dataRoom?.amenities;

        this.roomAmenits = newArray.slice(0,7);

    }
  }

  dailyPriceSelect(roomSelect: any){

    this.dailyPricesArr = [];

    roomSelect?.room?.pricing?.dailyPrices.forEach((dailyPrice: any) => {
      const roomDate = new Date(dailyPrice.date + 'T00:00:00'); // Ajustar la hora a las 00:00 horas
      const dayOfWeek = this.getDayOfWeek(roomDate.getDay()); // Obtener el día de la semana en español

      this.dailyPricesArr.push({
        dayWeek: dayOfWeek,
        date: dailyPrice.date,
        price: dailyPrice.price,
        currency: dailyPrice.currency
      });

    });
  }

getDayOfWeek(day: number): string {
  const daysOfWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  return daysOfWeek[day];
}

  openPolitics(): void {

      this.toggleDetail(0,this.groupedRoomOptions[0]);


      const eventOpen = {item: this.getAccordionDetailItems(this.roomSelect)[0], isOpen: true, index: 0};
      this.onAccordionDetailToggle(eventOpen);

      setTimeout(() => {


           if(this.accordionDetailComponent) {
            this.accordionDetailComponent.forEach((accordion: AccordionInfoProductComponent, index: number) => {



              if(index === 0) {
                accordion.openItem('policies');
                accordion.isOpen('policies');
              } else {
              }
             });

           }
           this.cdr.detectChanges();
      }, 150);

  }

/**
 * Busca y configura la información de la habitación seleccionada
 */
foundIdRoom(): void {
  try {
    const DEFAULT_IMAGE = 'assets/img/app/hotel_default.png';

    // Validaciones en cadena con operadores optional chaining
    const roomId = this.roomSelect?.room?.roomId;
    const rooms = this.hotelAdditionalInfo?.roomInfo?.rooms;
    let alternativeImage = '';

    if (!roomId || !rooms) {
      this.roomImage = DEFAULT_IMAGE;
      this.imageRoomById = [];
      return;
    }

    // Buscar habitación con validaciones
    const objectImageRoom = rooms.find((room: any) =>
      room?.code_room?.toString() === roomId.toString()
    );


      if(this.roomSelect?.room?.images && this.roomSelect?.room?.images.length > 0) {
        alternativeImage = this.roomSelect?.room?.images[0];
      }


    if (!objectImageRoom && alternativeImage === '') {
      this.roomImage = DEFAULT_IMAGE;
      this.imageRoomById = [];
      return;
    }

    // Obtener imagen con validaciones
    this.roomImage = objectImageRoom?.images?.[0]?.url || alternativeImage || DEFAULT_IMAGE;
    this.imageRoomById = [objectImageRoom?.images?.[0]?.url || alternativeImage || DEFAULT_IMAGE];

    // si no está buscar primero en images

  } catch (error) {
    console.error('Error configurando habitación:', error);
    this.roomImage = 'assets/img/app/hotel_default.png';
    this.imageRoomById = [];
  }
}

verifiedOtherOptions(roomsSearch: any[], roomBoardName: string, roomSelect: any): string {

  // Si no hay habitaciones para buscar, no hay alternativas
  if (!roomsSearch || roomsSearch.length === 0) {
    return '';
  }

  // Excluir la habitación actual (roomSelect)
  const otherRooms = roomsSearch.filter(room => {
    const currentRoomId = roomSelect?.room?.roomId || roomSelect?.room?.roomCode;
    const otherRoomId = room?.room?.roomId || room?.room?.roomCode;
    return otherRoomId !== currentRoomId;
  });

  // Si no hay otras habitaciones, no hay alternativas
  if (otherRooms.length === 0) {
    return '';
  }

  // Verificar si alguna de las otras habitaciones es válida según los filtros
  const hasValidAlternative = otherRooms.some(room => {
    const qtyAdults = Number(room.qtyAdults);
    const qtyChildren = Number(room.qtyChilds);
    const childAges = room.childsage || [];
    const expectedAgeRange = roomSelect?.room?.ageRangeChild || [];
    const rateClass = room?.room?.rateClass; // Obtener rateClass de la habitación alternativa

    // ✅ 1. Validar condiciones de pago (reembolsable)
    const isValidPayment = this.validPaymentConditionAgencyAvailable(rateClass);
    if (!isValidPayment) {
      return false;
    }

    // ✅ 2. Validar capacidad
    const roomConfig = roomSelect?.room?.availability;
    const validAdults = !roomConfig?.maxAdults || qtyAdults <= roomConfig.maxAdults;
    const validChildren = !roomConfig?.maxChildren || qtyChildren <= roomConfig.maxChildren;
    const validTotal = !roomConfig?.maxPax || (qtyAdults + qtyChildren) <= roomConfig.maxPax;

    if (!validAdults || !validChildren || !validTotal) {
      return false;
    }

    // ✅ 3. Validar rangos de edad
    if (expectedAgeRange.length > 0 && qtyChildren > 0) {
      const minAge = expectedAgeRange[0];
      const maxAge = expectedAgeRange[1];

      for (let i = 0; i < qtyChildren; i++) {
        let age = childAges[i];
        age = age?.age || age;
        if (age < minAge || age > maxAge) {
          return false;
        }
      }
    }

    return true;
  });

  return hasValidAlternative
    ? ` Sin embargo, puede seleccionar otras alternativas disponibles en la sección Opciones de habitación.`
    : '';
}

verifiedValidSelected(roomSelect: any): string {
  // ✅ 1. Validar condiciones de pago (primero, por ser independiente)
  if (!this.validPaymentConditionAgencyAvailable(roomSelect?.room?.rateClass)) {
    return `No es posible seleccionar esta habitación con tarifa no reembolsable debido a las condiciones de pago establecidas por la agencia.`;
  }

  // ✅ 2. Validar disponibilidad general
  if (this.isSelectDisabled(roomSelect)) {
    return `No es posible seleccionar esta habitación debido a su disponibilidad.`;
  }

  // ✅ 3. Validar que haya habitaciones disponibles (capacidad + edades)
  const availableRooms = this.roomValidSelected(this.roomsSearch);
  if (availableRooms.length === 0) {
    // Verificar cuál fue la razón
    const hasCapacityIssue = this.hasCapacityIssue();
    const hasAgeIssue = !this.validRangeAgeChildren(roomSelect);

    if (hasAgeIssue) {
      return `No es posible seleccionar esta habitación debido a la edad de niños admitida en la habitación.`;
    }

    if (hasCapacityIssue) {
      return `No es posible seleccionar esta habitación debido a la capacidad de la habitación.`;
    }

    return `No es posible seleccionar esta habitación.`;
  }

  return '';
}

// Método auxiliar para verificar si hay problema de capacidad
private hasCapacityIssue(): boolean {
  const roomConfig = this.roomSelect?.room?.availability;
  if (!roomConfig) {
return false;
}

  return !this.roomsSearch.some(room => {
    const qtyAdults = Number(room.qtyAdults);
    const qtyChildren = Number(room.qtyChilds);
    const total = qtyAdults + qtyChildren;

    return qtyAdults <= (roomConfig.maxAdults || Infinity) &&
           qtyChildren <= (roomConfig.maxChildren || Infinity) &&
           total <= (roomConfig.maxPax || Infinity);
  });
}

validRangeAgeChildren(roomSelect: any): boolean {
  const expectedAgeRange = roomSelect?.room?.ageRangeChild || []; // [min, max]


  if (expectedAgeRange.length === 0) {
    return true;
  }

  const hasChildren = this.roomsSearch.some(room => Number(room.qtyChilds) > 0);
  if (!hasChildren) {
    return true;
  }

  const minAge = expectedAgeRange[0];
  const maxAge = expectedAgeRange[1];

  for (const room of this.roomsSearch) {
    const qtyChildren = Number(room.qtyChilds);
    const childAges = room.childsage || [];

    for (let i = 0; i < qtyChildren; i++) {
      let age = childAges[i];
      age = age?.age || age;


      if (age < minAge || age > maxAge) {
        return false;
      }
    }
  }

  return true;
}

roomValidSelected(rooms: any): any[] {
  if (!rooms || rooms.length === 0) {
return [];
}

  const roomConfig = this.roomSelect?.room?.availability;
  const expectedAgeRange = this.roomSelect?.room?.ageRangeChild || []; // [min, max]

  const results = rooms.map(room => {
    const maxAdults = roomConfig?.maxAdults;
    const maxChildren = roomConfig?.maxChildren;
    const maxTotal = roomConfig?.maxPax;
    const qtyAdults = Number(room.qtyAdults);
    const qtyChildren = Number(room.qtyChilds);
    const total = qtyAdults + qtyChildren;
    const childAges = room.childsage || [];

    // Filtro 1: Capacidad de adultos
    const filter1 = !maxAdults || qtyAdults <= maxAdults;

    // Filtro 2: Capacidad de niños
    const filter2 = !maxChildren || qtyChildren <= maxChildren;

    // Filtro 3: Capacidad total
    const filter3 = !maxTotal || total <= maxTotal;

    // Filtro 4: Rangos de edad (solo si hay niños y hay rango definido)
    let filter4 = true;
    const minAge = expectedAgeRange[0];
    const maxAge = expectedAgeRange[1];

    if (expectedAgeRange.length > 0 && qtyChildren > 0) {
      for (let i = 0; i < qtyChildren; i++) {
        let age = childAges[i];
        age = age?.age || age; // Extraer la edad si es objeto

        if (age < minAge || age > maxAge) {
          filter4 = false;
          break;
        }
      }
    } else if (expectedAgeRange.length === 0) {
    } else if (qtyChildren === 0) {
    }

    const passed = filter1 && filter2 && filter3 && filter4;

    return { room, passed };
  });

  const filteredRooms = results.filter(r => r.passed).map(r => r.room);

  return filteredRooms;
}

  validPaymentConditionAgencyAvailable(rateClass: any): boolean {

    const result = rateClass === 'NR'
      ? this.paymentAgencyActive.non_refundable === 0 ? false : true
      : true;

    return result;
  }

toggleAddons(room: any, extra: any, extraPrice: number): void {
  const index = room.addonsIncluded.findIndex(a => a.optionid === extra.optionid);

  if (index >= 0) {
    // Deseleccionar
    room.addonsIncluded.splice(index, 1);
    room.netPriceBookingAddons -= extraPrice;
  } else {
    // Seleccionar nuevo (remover todos los anteriores primero)
    const previousAddonsPrice = room.addonsIncluded.reduce((total, addon) => total + (addon.netcost?.amountprof || 0), 0);

    room.addonsIncluded = [extra]; // Solo mantener el nuevo
    room.netPriceBookingAddons = room.netPriceBookingAddons - previousAddonsPrice + extraPrice;
  }

  this.refreshCalculatePrice.emit();
}

addonsIsSelected(room: any, extra: any): boolean {
  if (!room.addonsIncluded || room.addonsIncluded.length === 0) {
    return false;
  }
  // Como solo puede haber uno seleccionado, comparamos con el primero
  return room.addonsIncluded[0].optionid === extra.optionid;
}

// Función para sanitizar el HTML
sanitizeHtml(html: string) {
  return this.sanitizer.bypassSecurityTrustHtml(html || '');
}

// Función para mostrar/ocultar detalles
toggleDetails(index: number): void {
  this.showDetails[index] = !this.showDetails[index];
}

getBoardType(boardName: string): string {
  if (!boardName) {
return 'default';
}

  const normalizedName = boardName.toLowerCase().trim();

  for (const type of BoardTypes) {
    const matches = type.matches.some(match =>
      normalizedName.includes(match.toLowerCase())
    );
    if (matches) {
      return type.key;
    }
  }

  return 'default';
}

getBoardIcon(boardName: string): string {
  if (!boardName) {
return this.DEFAULT_ICON;
}

  const boardType = this.getBoardType(boardName);

  // Si encontramos un tipo válido, devolvemos su icono
  if (boardType !== 'default' && this.BOARD_ICONS[boardType]) {
    return this.BOARD_ICONS[boardType];
  }

  // Si no, devolvemos el default
  return this.DEFAULT_ICON;
}
getRoomSelect(room): void {
}


// En lugar de usar el precio como clave, usa el objeto room directamente
// Guardar el estado de selección de extras por habitación
private nextRoomId = 0;
// private extrasMap = new Map<number, any[]>(); // ID -> extras
private priceModifiersMap = new Map<number, number>(); // ID -> modifier
private selectionState = new Map<number, Map<string, boolean>>(); // ID -> estado

// Inicializar estado cuando se agrega una habitación
private initRoomSelectionState(room: any): void {
  const roomId = room._uniqueId;
  if (!this.selectionState.has(roomId)) {
    this.selectionState.set(roomId, new Map());
  }
  if (!this.extrasMap.has(roomId)) {
    this.extrasMap.set(roomId, []);
  }
  if (!this.priceModifiersMap.has(roomId)) {
    this.priceModifiersMap.set(roomId, 0);
  }
}

// Cuando agregas una habitación a selectedRooms
addRoom(room: any): void {
  // ✅ Generar una key única con los campos que ya tienes



  const roomData = room.service || room;
  const uniqueKey = `${roomData?.roomCode || ''}_${roomData?.roomType || ''}_${roomData?.boardName || ''}_${roomData?.rateClass || ''}`;
  // ✅ Verificar si ya existe por la key
  const existingIndex = this.selectedRooms.findIndex(r => {
    const rData = r.service.room || r;
    const rKey = `${rData?.roomCode || ''}_${rData?.roomType || ''}_${rData?.boardName || ''}_${rData?.rateClass || ''}`;
    return rKey === uniqueKey;
  });

  const roomWithId = {
    ...room,
    _uniqueId: this.nextRoomId++,
    _uniqueKey: uniqueKey
  };

  if (existingIndex !== -1) {
    // ✅ Si ya existe, actualizar
    this.selectedRooms[existingIndex] = roomWithId;
  } else {
    // ✅ Si no existe, agregar
    this.selectedRooms.push(roomWithId);
  }

  this.initRoomSelectionState(roomWithId);
}

trackByRoomId(index: number, room: any): number {
  return room._uniqueId || index;
}

private normalizeExtra(extra: any): any {
  // Para Hotel Supplements, el optionid puede venir directamente o dentro de options
  let optionid = extra.optionid;
  let title = extra.title;
  let description = extra.description;
  let price = extra.netcost?.amountProf || 0;
  let currency = extra.netcost?.currency;

  // Si no tiene optionid pero tiene options, extraer de la primera opción
  if (!optionid && extra.options && extra.options.length > 0) {
    const option = extra.options[0];
    optionid = option.optionid;
    title = option.title || extra.title;
    description = option.description || extra.description;
    price = option.netcost?.amountProf || 0;
    currency = option.netcost?.currency;
  }

  return {
    optionid,
    title,
    name: title,
    description,
    price,
    currency,
    icon: this.getIconByType(extra.type),  // extra.type ya viene del tab
    type: extra.type,  // Ya viene del tab
    tab: extra.tab,
    netcost: extra.netcost || { amountProf: price, currency }
  };
}
// Obtener icono según el tipo de extra
private getIconByType(type: string): string {
  const iconMap: { [key: string]: string } = {
    Transfer: '../../../../../assets/img/app/categories-search-box/bus.svg',
    Attractions: '../../../../../assets/icons/search-box/atracciones.svg',
    'Hotel Supplements': '../../../../../assets/icons/search-result/hotel/icono_sugerencias.svg'
  };
  return iconMap[type] || '../../../../../assets/icons/itinerary/addon-default.svg';
}

// Cambiar la estructura de extrasMap para que use clave compuesta
public extrasMap = new Map<string, any[]>(); // clave: `${roomId}_${tab}`

onSelectionChangeExtras(event: any, extra: any, tab: string): void {
  const currentSelectedRooms = event.value || [];
  const currentSelectedRoomIds = currentSelectedRooms.map((room: any) => room._uniqueId);
  const extraType = this.getTypeByTab(tab);

  const normalizedExtra = this.normalizeExtra({
    ...extra,
    type: extraType,
    tab
  });
  this.selectedRooms.forEach((room: any) => {
    const roomId = room._uniqueId;
    const mapKey = `${roomId}_${tab}`; // Clave única por habitación y tipo de extra
    const wasSelected = this.selectionState.get(roomId)?.get(normalizedExtra.optionid) || false;
    const isSelected = currentSelectedRoomIds.includes(roomId);

    if (isSelected && !wasSelected) {
      let roomExtras = this.extrasMap.get(mapKey) || [];
      if (!roomExtras.find(e => e.optionid === normalizedExtra.optionid)) {
        roomExtras = [...roomExtras, normalizedExtra];
        this.extrasMap.set(mapKey, roomExtras);

        // Sumar al precio total de la habitación (acumular todos los tabs)
        const currentModifier = this.priceModifiersMap.get(roomId) || 0;
        this.priceModifiersMap.set(roomId, currentModifier + (normalizedExtra.price));
      }
      if (!this.selectionState.has(roomId)) {
        this.selectionState.set(roomId, new Map());
      }
      this.selectionState.get(roomId)!.set(normalizedExtra.optionid, true);
    } else if (!isSelected && wasSelected) {
      const roomExtras = this.extrasMap.get(mapKey) || [];
      const extraIndex = roomExtras.findIndex(e => e.optionid === normalizedExtra.optionid);
      if (extraIndex >= 0) {
        roomExtras.splice(extraIndex, 1);
        this.extrasMap.set(mapKey, roomExtras);

        // Restar del precio total
        const currentModifier = this.priceModifiersMap.get(roomId) || 0;
        this.priceModifiersMap.set(roomId, currentModifier - (normalizedExtra.price));
      }
      this.selectionState.get(roomId)!.set(normalizedExtra.optionid, false);
    }
  });

  // Actualizar servicios
  this.selectedRooms.forEach((room: any) => {
    const roomId = room._uniqueId;
    // Combinar todos los extras de todos los tabs para esta habitación
    const allExtras = [
      ...(this.extrasMap.get(`${roomId}_transfer`) || []),
      ...(this.extrasMap.get(`${roomId}_attractions`) || []),
      ...(this.extrasMap.get(`${roomId}_Hotel Supplements`) || [])
    ];
    this.updateRoomServiceExtras(room, roomId, allExtras);
  });

  this.cdr.detectChanges();
  this.refreshCalculatePrice.emit(this.selectedRooms);
}

private updateRoomServiceExtras(room: any, roomId: number, extras: any[]): void {
  const extrasTotal = extras.reduce((sum, e) => sum + (e.price || 0), 0);

  if (!room.room) {
room.room = {};
}
  room.room.addonsIncluded = [...extras];
  room.room.netPriceBookingAddons = extrasTotal;

  if (!room.service) {
room.service = {};
}
  room.service.addonsIncluded = [...extras];
  room.service.netPriceBookingAddons = extrasTotal;

}


getTypeByTab(tab: string): string {
  const typeMap: { [key: string]: string } = {
    transfer: 'Transfer',
    attractions: 'Attractions',
    'Hotel Supplements': 'Hotel Supplements'
  };
  return typeMap[tab] || '';
}

// Getter para el precio final (base + extras)
getFinalPrice(room: any): number {
  const basePrice = this.currencyPipe.transform(
    room?.service?.optionNightsNetTotalProf,
    room?.service?.pricing?.currency,
    this.currencyAgency.code,
    this.currencies
  );

  const modifierRaw = this.priceModifiersMap.get(room._uniqueId) || 0;
  const modifier = this.currencyPipe.transform(
    modifierRaw,
    room?.service?.pricing?.currency,
    this.currencyAgency.code,
    this.currencies
  );


  return basePrice + modifier;
}

// Obtener icono del extra (ahora viene en el objeto)
getIconsExtras(room: any): string {
  const extras = this.getRoomExtras(room);
  if (extras.length === 0) {
return '';
}
  return extras[0]?.icon || '../../../../../assets/icons/itinerary/addon-default.svg';
}

// Obtener texto de los extras
getTextExtras(room: any): string {
  const extras = this.getRoomExtras(room);
  if (extras.length === 0) {
return '';
}
  return extras.map(e => e.title || e.name).join(', ');
}

  getCancellationPolicies(): ICancellationPolicyModalResultsDisplayData {
    return {
      rateClass: this.roomSelect?.room?.rateClass,
      cancellationPolicies: this.roomSelect?.room?.cancellationPolicy || [],
      currencyCancellation: this.roomSelect?.room?.cancellationPolicy && this.roomSelect?.room?.cancellationPolicy.length > 0 ? this.roomSelect?.room?.cancellationPolicy[0].currency : this.roomSelect?.room?.pricing?.currency,
      amount: this.roomSelect?.room?.cancellationPolicy?.find(c => c.amount > 0)?.amountProf || 0,
      from: this.roomSelect?.room?.cancellationPolicy?.find(c => c.amount > 0)?.from || 'N/A',
      cancellationFree: this.roomSelect?.room?.cancellationPolicy?.some(c => Number(c.amount) === 0),
      arrivalDate: this.arrivalDate
    };
  }

  getCancellationPolicyFrom(room): Date | string {
    return room.cancellationPolicy?.find(c => c.amount > 0)?.from || 'N/A';
  }

get detailRoomData(): IDetailRoomsModalHotelDisplayData {
  return {
    roomImage: this.roomImage,
    logoProvider: this.roomSelect?.provider?.logo,
    maxAdults: this.roomSelect?.room?.availability?.maxAdults,
    maxChildren: this.roomSelect?.room?.availability?.maxChildren,
    rateClass: this.roomSelect?.room?.rateClass,
    dailyPrices: this.roomSelect.room.pricing?.dailyPrices,
    dailyPricesArr: this.dailyPricesArr,
    netPriceProf: this.roomSelect?.room?.netPriceProf,
    priceTaxExcluded: this.roomSelect?.room.pricing.taxesExcluded,
    currencyProduct: this.roomSelect?.room?.pricing?.currency,
    allotment: this.roomSelect?.room?.availability?.allotment,
    boardName: this.roomSelect?.room?.boardName,
    optionNightsNetTotalProf: this.roomSelect?.room?.optionNightsNetTotalProf,
    ageRangeChild: this.roomSelect?.room?.ageRangeChild,
    titleRoom: this.roomSelect.room.roomType
  };
}

onAccordionDetailToggle(value: any): void {
const index = value.index;
  // ✅ Forzar el estado según lo que viene
  this.isMainExpandedDetailExcutiveAction[index] = value.isOpen;

  }

  onAccordionToggle(index: number): void {
     this.isMainExpandedExcutiveAction[index] = !this.isMainExpandedExcutiveAction[index];
  }

getAccordionItems(): AccordionItem[] {
  return [
    {
      id: 'description',
      title: 'Descripción',
      icon: 'assets/icons/description.svg',
      data: { description: this.formatHotelDescription(this.hotelDescription) }
    },
    {
      id: 'amenities',
      title: 'Amenidades',
      icon: 'assets/icons/description.svg',
      data: { amenities: this.formatAmenities(this.hotelAdditionalInfo) }
    }
  ];
}

    /**
     * Formatea la descripción del hotel para que tenga estilos CSS
     */
private formatHotelDescription(html: string): SafeHtml {
  if (!html) {
return '';
}


  return this.sanitizer.bypassSecurityTrustHtml(html);
}

   getAccordionConfig(): AccordionConfig {
     return {
      multiple: false,
      animated: true,
      showArrows: true,
      borderTop: true,
      defaultOpen: ['description']
     };
    };

    clearSelection(): void {
  // Eliminar todas las habitaciones seleccionadas una por una
    const roomsToRemove = [...this.selectedRooms];
    roomsToRemove.forEach((room, index) => {
      this.offSelectionRooms(this.roomSelect, index, room, false);
    });
  }

  /**
   * Obtiene el icono para un extra específico
   */
getExtraIcon(extra: any): string {
  // Si el extra ya tiene icono, usarlo
  if (extra.icon) {
    return extra.icon;
  }

  // Si no, asignar según el tipo
  const iconMap: { [key: string]: string } = {
    Transfer: '../../../../../assets/img/app/categories-search-box/bus.svg',
    Attractions: '../../../../../assets/icons/search-box/atracciones.svg',
    'Hotel Supplements': '../../../../../assets/icons/itinerary/bed-svgrepo-com.svg'
  };

  return iconMap[extra.type] || '../../../../../assets/icons/itinerary/addon-default.svg';
}

/**
 * Obtiene el tipo legible del extra
 */
getExtraType(extra: any): string {
  const typeMap: { [key: string]: string } = {
    Transfer: 'Traslado',
    Attractions: 'Atracción',
    'Hotel Supplements': 'Sugerencias'
  };
  return typeMap[extra.type] || extra.type || 'Extra';
}

/**
 * Obtener todos los extras de una habitación (ya existe)
 */
getRoomExtras(room: any): any[] {
  const roomId = room._uniqueId;
  // ✅ Usar los mismos nombres de clave que se usan al guardar
  const allExtras = [
    ...(this.extrasMap.get(`${roomId}_transfer`) || []),
    ...(this.extrasMap.get(`${roomId}_attractions`) || []),
    ...(this.extrasMap.get(`${roomId}_Hotel Supplements`) || [])
  ];
  return allExtras;
}

getChildrenAge(item): string {
  if (!item?.childsage || item.childsage.length === 0) {
    return '';
  }

  const ages = item.childsage.map(c => c.age).join(', ');
  const hasMultiple = item.childsage.length > 1;

  return `(${ages} ${hasMultiple ? 'años' : 'año'})`;
}

// nuevos

selectedRoomAssignments: { [groupKey: string]: any[] } = {};

availableConfigsForGroup(group: any): void {
  const roomConfigs = this.payload?.others?.hotels?.roomConfiguration || [];
  const availableConfigs: any[] = [];
  const assignedConfigs = this.selectedRoomAssignments[group.key] || [];
  const assignedIndexes = assignedConfigs.map((a: any) => a.configIndex);
  const maxRooms: any = 9;

  roomConfigs.forEach((config: any, index: number) => {
    // ✅ Saltar configuraciones ya asignadas a este grupo
    if (assignedIndexes.includes(index)) {
return;
}

    const totalPax = (config.adults || 0) + (config.children?.length || 0);

    // ✅ Buscar una opción en el grupo que coincida con la ocupación
    const match = group.options.find((o: any) => o.room.occupancyRoom === index);
    if (match) {
      availableConfigs.push({
        configIndex: index,
        config,
        totalPax,
        option: match
      });
    }
  });

    for(let i = availableConfigs.length; i < maxRooms; i++) {
      availableConfigs.push({
          configIndex:null,
          config: null,
          totalPax: null,
          option: null
        });
  }


  this.availableConfigs = availableConfigs;
}



/**
 * Asigna una opción de ocupación a una configuración específica dentro del grupo
 */
assignOccupancyToConfig(group: any, option: any, configIndex: number): void {
  // ✅ Verificar si la configuración ya fue asignada a este grupo
  const currentAssignments = this.selectedRoomAssignments[group.key] || [];
  if (currentAssignments.some((a: any) => a.configIndex === configIndex)) {
return;
}

  // ✅ Verificar si la configuración ya fue asignada a otro grupo
  const isAssignedElsewhere = Object.keys(this.selectedRoomAssignments).some((key: string) => {
    if (key === group.key) {
return false;
}
    return this.selectedRoomAssignments[key].some((a: any) => a.configIndex === configIndex);
  });

  if (isAssignedElsewhere) {
    this.notificationService.warning('Esta configuración ya fue asignada a otra habitación');
    return;
  }

  // ✅ Guardar la asignación en el grupo
  if (!this.selectedRoomAssignments[group.key]) {
    this.selectedRoomAssignments[group.key] = [];
  }

  this.selectedRoomAssignments[group.key].push({
    configIndex,
    option,
    occupancy: option.room.occupancyRoom,
    adults: option.room.occupancyRoom,
    children: 0,
    childrenAges: []
  });

}

openTooltipPromotion(configRoom: any): void {
  console.log(configRoom);
}

/**
 * Elimina una asignación de configuración del grupo
 */
removeAssignment(groupKey: string, configIndex: number): void {
  if (!this.selectedRoomAssignments[groupKey]) {
return;
}

  this.selectedRoomAssignments[groupKey] = this.selectedRoomAssignments[groupKey]
    .filter((a: any) => a.configIndex !== configIndex);

  if (this.selectedRoomAssignments[groupKey].length === 0) {
    delete this.selectedRoomAssignments[groupKey];
  }
}

/**
 * Verifica si una configuración ya fue asignada a este grupo
 */
isConfigAssignedToGroup(groupKey: string, configIndex: number): boolean {
  const assignments = this.selectedRoomAssignments[groupKey] || [];
  return assignments.some((a: any) => a.configIndex === configIndex);
}

/**
 * Verifica si una configuración ya fue asignada a algún grupo
 */
isConfigAssignedAnywhere(configIndex: number): boolean {
  return Object.keys(this.selectedRoomAssignments).some((key: string) => this.selectedRoomAssignments[key].some((a: any) => a.configIndex === configIndex));
}

/**
 * Obtiene el total de configuraciones asignadas a un grupo
 */
getAssignedCount(groupKey: string): number {
  return this.selectedRoomAssignments[groupKey]?.length || 0;
}

/**
 * Verifica si todas las configuraciones están asignadas
 */
isAllConfigsAssigned(): boolean {
  const totalConfigs = this.payload?.others?.hotels?.roomConfiguration?.length || 0;
  const totalAssigned = Object.values(this.selectedRoomAssignments).reduce(
    (sum: number, assignments: any[]) => sum + assignments.length, 0
  );
  return totalAssigned === totalConfigs;
}

// Nuevos métodos

// Agrega logs para ver qué está pasando
isOccupancyRoomSelected(occupancyRoom: number, room?: any): boolean {

  if(!room || !occupancyRoom) {
    return false;
  }

  const selectedRooms = this.hotelService.getConfigSelectedRoom();

  const key: string = this.getOccupancyRoomGroupKey(occupancyRoom) || '';

  const roomKey = `${room?.option?.room?.roomType}_${room?.option?.room?.boardName}_${room?.option?.room?.rateClass}_${room?.option?.room?.roomCode}`;
  if(key !== roomKey) {
    return false;
  }


  if (!selectedRooms || !selectedRooms[key]) {
    return false;
  }

  const found = selectedRooms[key].find(
    item => item.room?.occupancyRoom === occupancyRoom
  );

  return !!found;
}

getOccupancyRoomGroupKey(occupancyRoom: number): string | null {
  return this.hotelService.getGroupKeyForOccupancyRoom(occupancyRoom);
}

addConfigSelectedRoom(configOccupancyRoom: any, groupedRoom: any): void {




  if(configOccupancyRoom?.isEmpty)  {
    return;
  }

  const groupedKey = `${groupedRoom.roomType}_${groupedRoom.key}`;
  const occupancyRoom = configOccupancyRoom.option?.room?.occupancyRoom;


  // ✅ Verificar si ya está seleccionado en otro grupo
  const existingGroupKey = this.getOccupancyRoomGroupKey(occupancyRoom);


  if (existingGroupKey && existingGroupKey !== groupedKey) {
    const initialState: ModalOptions = {
      initialState: {
        icon: 'assets/icons/itinerary-detail/ALERTA-01.svg',
        title: 'Importante',
        subtitle: '',
        message: `Esta configuración de habitación (${occupancyRoom} personas) ya está seleccionada en otra opción habitación. ¿Deseas moverla a está opción habitación?`,
      }
    };

    const modalOptions = Object.assign({}, initialState, this.config);
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, modalOptions);

    this.bsModalRef?.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        const occupancyInParent = this.selectedRoomsParent.find(c => c.room.room.occupancyRoom === occupancyRoom);
        const occupancyIndexInParent: number = this.selectedRoomsParent.findIndex(c => c.room.room.occupancyRoom === occupancyRoom);

        if (occupancyInParent && occupancyIndexInParent > -1) {
          // ✅ 1. Eliminar del origen (esto notifica a los otros hijos)
          this.offSelectionRooms(
            configOccupancyRoom?.option,
            occupancyIndexInParent,
            occupancyInParent,
            true,
            true,
            occupancyInParent
          );

          setTimeout(() => {
            // ✅ 2. Agregar al destino
            this.toggleAction(configOccupancyRoom, groupedKey, occupancyRoom, groupedRoom);



            // ✅ 3. NOTIFICAR AL PADRE QUE SE AGREGÓ
            this.roomAdded.emit({
              occupancyRoom,
              roomData: configOccupancyRoom.option.room,
              groupedKey,
              targetGroupKey: groupedKey
            });

          }, 10);
        }
      } else {
        return;
      }
    });
  } else {
    this.toggleAction(configOccupancyRoom, groupedKey, occupancyRoom, groupedRoom);
  }
}

getAllotment(groupedRoom: any): number {

  return groupedRoom[0].allotment - this.getSelectedCountByRoomCode(groupedRoom[0]?.roomCode) || 0;

}

/**
 * El allotment pertenece al cuarto físico (roomCode), no a cada opción de tarifa
 * (con desayuno / sin desayuno / reembolsable / etc. son la misma habitación).
 * Por eso acá se suman las selecciones de TODOS los grupos que compartan roomCode,
 * sin importar boardName/rateClass, contra el allotment de ese roomCode.
 */
 getSelectedCountByRoomCode(roomCode: string): number {
  if (!roomCode) {
    return 0;
  }

  const selectedRooms = this.hotelService.getConfigSelectedRoom();

  return Object.values(selectedRooms).reduce((count: number, options: any[]) =>
    count + options.filter((opt: any) => opt?.room?.roomCode === roomCode).length, 0);
}

/**
 * Disponibilidad restante para el cuarto físico de este grupo, calculada en vivo a
 * partir de lo que ya está seleccionado en el hotelService (nunca se muta el
 * allotment original).
 */
getAllotmentRoom(groupedRoom: any): boolean {
  const allotment = groupedRoom?.allotment || 0;
  const selectedCount = this.getSelectedCountByRoomCode(groupedRoom?.roomCode);

  return selectedCount >= allotment;
}

toggleAction(configOccupancyRoom: any, groupedKey: any, occupancyRoom: any, groupedRoom: any): void {

                // ✅ Si esta habitación ya está seleccionada en este grupo, la acción es una baja:
                // la baja nunca debe bloquearse por falta de allotment (al contrario, lo libera).
                const isCurrentlySelected = this.isOccupancyRoomSelected(occupancyRoom, configOccupancyRoom);

                if (!isCurrentlySelected) {
                  const emptyAllotment = this.getAllotmentRoom(groupedRoom);

                  if (emptyAllotment) {
                    this.notificationService.info('No es posible asignar más habitaciones en está opción débido a que no hay más disponibilidad');
                    return;
                  }
                }

                // ✅ Agregar o mover la selección
                configOccupancyRoom.option.config = configOccupancyRoom.config;
                const roomCode = groupedRoom?.roomCode || this.room?.[0]?.room?.roomCode;

                const isSelected = this.hotelService.toggleConfigSelectedRoom(
                  groupedKey,
                  configOccupancyRoom.option,
                  roomCode,
                );

                if (isSelected) {
                  this.addRoomsSelected(groupedRoom);

                   this.notificationService.success('Habitación seleccionada');
                } else {
                  this.notificationService.info('Habitación deseleccionada');

                  if(this.selectedRoomsParent.length > 0) {
                    let selectedRoom = this.selectedRoomsParent.find(c => c.service?.occupancyRoom === occupancyRoom);
                    let index = this.selectedRoomsParent.findIndex(c => c.service?.occupancyRoom === occupancyRoom);


                    if(!selectedRoom) {
                      selectedRoom = this.selectedRoomsParent.find(c => c.room?.room?.occupancyRoom === occupancyRoom);
                      index = this.selectedRoomsParent.findIndex(c => c.room?.room?.occupancyRoom === occupancyRoom);
                    }

                    if(selectedRoom) {
                      this.offSelectionRooms(configOccupancyRoom, index, selectedRoom, true);
                    }

                  }

                }
}


addRoomsSelected(room: any, ocuppancyOtherRoom?: boolean, configOccupancyRoom?: any): void {



  if(!room?.rateClass || !this.validPaymentConditionAgencyAvailable(room?.rateClass)) {
    this.notificationService.error('No es posible seleccionar un producto "no reembolsable" debido a las condiciones de pago de la agencia');
    return;
  }



  if(ocuppancyOtherRoom) {


      const roomProduct = {
        room
      };
        this.addConfigSelectedRoom(configOccupancyRoom, roomProduct);


  }

  let selectedRooms = this.hotelService.getConfigSelectedRoom();

  if (!selectedRooms || Object.keys(selectedRooms).length === 0) {



            room.availableConfigs.forEach((config: any) => {
            if(config?.configIndex !== null) {
                this.addConfigSelectedRoom(config, room);
            }
        });




    selectedRooms = this.hotelService.getConfigSelectedRoom();

  }

  if(Object.keys(selectedRooms).length > 0) {

    const key = `${room.roomType}_${room.boardName}_${room.rateClass}_${room.roomCode}`;

    if(!selectedRooms[key]) {

      room.availableConfigs.forEach((config: any) => {
        if(config?.configIndex !== null) {
            this.addConfigSelectedRoom(config, room);
        }
        });

        selectedRooms = this.hotelService.getConfigSelectedRoom();

    }

  }





  Object.keys(selectedRooms).forEach(groupKey => {
      const rooms = selectedRooms[groupKey];

      // ✅ Si hay habitaciones en este grupo, enviarlas
      if (rooms && rooms.length > 0) {

        rooms.forEach(room => {

          // if(room?.room?.room) {
          //   room = room?.room;
          //   room.adults = 1;
          //   room.children = 0;
          //   room.childsAge = [];
          // } else {

          // }

          const data = { target: { value: {
                adults: room.config?.adults,
                childs: room.config?.children.length,
                room
              }}};
          // ✅ Llamar a onSelectionChange con cada habitación
          // Ajustá los parámetros según la firma de tu método
          this.onSelectionChange(JSON.stringify(data), room);
        });
      }
    });

}

open(item: any, isOpen: boolean, index: number): void {
  setTimeout(() => {
    if (this.accordionDetailComponent) {
      this.accordionDetailComponent.forEach((accordion: AccordionInfoProductComponent, i: number) => {
        if (i === index) {
          // ✅ Verificar si está abierto
          const isCurrentlyOpen = accordion.isOpen('policies');

          if (isCurrentlyOpen) {
            // ✅ Si está abierto, cerrarlo
            accordion.closeItem('policies');
          } else {
            // ✅ Si está cerrado, abrirlo
            accordion.openItem('policies');
          }
        } else {
          // ✅ Cerrar los otros acordeones (si no es múltiple)
          accordion.closeItem('policies');
        }
      });
    }
    this.cdr.detectChanges();
  }, 150);
}

  getCancellationDetailPolicies(room): ICancellationPolicyModalResultsDisplayData {
    return {
      rateClass: room?.room?.rateClass,
      cancellationPolicies: room?.room?.cancellationPolicy || [],
      currencyCancellation: room?.room?.cancellationPolicy && room.room?.cancellationPolicy.length > 0 ? room.room?.cancellationPolicy[0].currency : room.room?.pricing?.currency,
      amount: room?.room?.cancellationPolicy?.find(c => c.amount > 0)?.amountProf || 0,
      from: room?.room?.cancellationPolicy?.find(c => c.amount > 0)?.from || 'N/A',
      cancellationFree: room?.room?.cancellationPolicy?.some(c => Number(c.amount) === 0),
      arrivalDate: this.arrivalDate
    };
  }

  getAccordionDetailItems(room): AccordionItem[] {
  return [
    {
      id: 'policies',
      title: 'Políticas de Cancelación y Penalidades',
      icon: 'assets/icons/policy.svg',
      data: { policies: this.getCancellationDetailPolicies(room) } // NOTA: aquí también debes cambiar
    }
  ];
}

   getAccordionDetailConfig(): AccordionConfig {
     return {
      multiple: false,
      animated: true,
      showArrows: true,
      borderTop: true,
      defaultOpen: []
     };
    };

    // En el componente hijo (usb-room)
/**
 * ✅ Método público que el padre llama cuando un occupancyRoom fue movido desde otro hijo
 */
onRoomMovedFromAnother(occupancyRoom: number, sourceGroupKey: string): void {
  // Buscar en el selectedRooms local si tiene este occupancyRoom
  const localIndex = this.selectedRooms.findIndex(
    item => item?.service?.occupancyRoom === occupancyRoom ||
            item?.room?.occupancyRoom === occupancyRoom
  );

  if (localIndex !== -1) {
    // ✅ Eliminar de la lista local
    const removedRoom = this.selectedRooms.splice(localIndex, 1)[0];

    // ✅ Limpiar del servicio si es necesario
    if (removedRoom) {
      const service = removedRoom?.service || removedRoom?.room;
      const groupedKey = `${service?.roomType}_${service?.boardName}_${service?.rateClass}_${service?.roomCode}`;
      const roomObj = { room: service };
      this.hotelService.toggleConfigSelectedRoom(groupedKey, roomObj, service?.roomCode, true);

          if (this.selectedRooms.length === 0) {
        this.contentBorderSelectTop.nativeElement.style.border = '1px solid #bfbfbf';
        this.contentBorderSelectTop.nativeElement.style.boxShadow = `none`;
        }
    }

  }
}

/**
 * ✅ Método público que el padre llama cuando un occupancyRoom fue eliminado completamente
 */
onRoomRemovedFromAnother(occupancyRoom: number): void {
  // Buscar en el selectedRooms local
  const localIndex = this.selectedRooms.findIndex(
    item => item?.service?.occupancyRoom === occupancyRoom ||
            item?.room?.occupancyRoom === occupancyRoom
  );

  if (localIndex !== -1) {
    const removedRoom = this.selectedRooms.splice(localIndex, 1)[0];

    if (removedRoom) {
      const service = removedRoom?.service || removedRoom?.room;
      const groupedKey = `${service?.roomType}_${service?.boardName}_${service?.rateClass}_${service?.roomCode}`;
      const roomObj = { room: service };
      this.hotelService.toggleConfigSelectedRoom(groupedKey, roomObj, service?.roomCode, true);

    if (this.selectedRooms.length === 0) {
    this.contentBorderSelectTop.nativeElement.style.border = '1px solid #bfbfbf';
    this.contentBorderSelectTop.nativeElement.style.boxShadow = `none`;
    }
    }


  }


}

toggleDetail(index: number, room: any): void {
  this.cancellationDetailData = this.getCancellationDetailPolicies(room.selectedOccupancy.option);
  this.accordionItemsDetailData = this.getAccordionDetailItems(room.selectedOccupancy.option);
  this.accordionConfigDetailData = this.getAccordionDetailConfig();


  const roomCode = `${room.roomType}_${room.key}`;
  if (roomCode) {

    this.hotelService.toggleRoomDetail(index, room, roomCode);
  }
}

// En el componente hijo (usb-room)
/**
 * ✅ Método público que el padre llama cuando un occupancyRoom fue agregado desde otro hijo
 */
onRoomAddedFromAnother(occupancyRoom: number, roomData: any, groupedKey: string): void {

  // Verificar si este hijo es el destino (por el groupedKey)
  const roomFind = this.room.find(c => `${c.room?.roomType}_${c.room?.boardName}_${c.room?.rateClass}_${c.room?.roomCode}` === groupedKey);

  // ✅ Solo agregar si la key coincide con este hijo
  if (!roomFind) {
    return; // No es este hijo
  }

  // Verificar si ya existe en selectedRooms
  const exists = this.selectedRooms.some(
                                            item => item?.service?.occupancyRoom === occupancyRoom ||
                                                    item?.room?.occupancyRoom === occupancyRoom
                                          );

  if (!exists) {
    // ✅ Agregar a la lista local
    const newRoom = {
      service: roomFind,
      room: roomFind,
    };
    this.selectedRooms.push(newRoom);
  }
}

onMouseEnter(event: MouseEvent, configRoom: any): void {
  console.log(configRoom)
  configRoom._promotionTooltipOpen = true;
}

onMouseLeave(event: MouseEvent, configRoom: any): void {
  configRoom._promotionTooltipOpen = false;
}

getPromotionConfigRoom(promotion): any {
  return promotion[0];
}

}
